import type { ReactNode } from 'react'
import { useIsUrlOrganizationRejected } from '@/hooks/use-tab-organization'

type TabOrganizationGateProps = {
  children: ReactNode
  rejectedFallback: ReactNode
}

/**
 * Sits above `PermissionGate` so a rejected `?org=` never mounts the authenticated tree: no
 * request of another organization is made and the user is not redirected to a different one.
 */
export function TabOrganizationGate({ children, rejectedFallback }: TabOrganizationGateProps) {
  const isRejected = useIsUrlOrganizationRejected()
  return <>{isRejected ? rejectedFallback : children}</>
}
